"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isManualOrImportCommandSource = exports.isManualCommandSource = exports.MANUAL_OR_IMPORT_COMMAND_SOURCES = exports.MANUAL_COMMAND_SOURCES = void 0;
const enums_1 = require("../enums");
exports.MANUAL_COMMAND_SOURCES = [enums_1.CommandSource.ManualEntry, enums_1.CommandSource.PublicApi];
exports.MANUAL_OR_IMPORT_COMMAND_SOURCES = [...exports.MANUAL_COMMAND_SOURCES, enums_1.CommandSource.Import];
const isManualCommandSource = (source) => Boolean(source && exports.MANUAL_COMMAND_SOURCES.includes(source));
exports.isManualCommandSource = isManualCommandSource;
const isManualOrImportCommandSource = (source) => Boolean(source && exports.MANUAL_OR_IMPORT_COMMAND_SOURCES.includes(source));
exports.isManualOrImportCommandSource = isManualOrImportCommandSource;
